import React from 'react';
import { visuallyHidden } from '@noths/polaris-client-styles';

import { Content } from '../Content/Content';
import * as styles from './Introduction.styles';

const logoURL =
  'https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/blt3381db1bb1ccad5b/652ea65c8dd295a3bcefc487/DGG-title.png';
const collageURL =
  'https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/blt438c7e75a84c4134/intro_images.png';

export const Introduction = () => {
  return (
    <div css={styles.root}>
      <Content key="intro1" backgroundColor="var(--dgg-well-read)">
        <div css={styles.content}>
          <p css={styles.subtitle}>Welcome to the</p>
          <h1 css={visuallyHidden}>DON&apos;T GIFT GUIDE</h1>
          <img src={logoURL} alt="" css={styles.logo} />
          <p css={styles.subtitle}>
            Gift fewer, gift better with our
            <br />
            small biz marketplace
          </p>
        </div>
      </Content>
      <Content key="intro2" backgroundColor="#6d69d9">
        <div css={styles.content}>
          <p css={styles.introductionCopy}>
            This Christmas, we&apos;re on a mission to help the nation gift better – and thanks to
            our talented small businesses, mis-gifting is a thing of the past. It&apos;s *extra*
            special prezzies only from now on.
          </p>
          <img
            src={collageURL}
            alt="Decorated Christmas tree and families celebrating with presents"
            css={styles.collage}
          />
        </div>
      </Content>
    </div>
  );
};
